import { WithChildren } from "types";
import styles from "./accordion-container.module.scss";
import { useAccordionContext } from "domain/accordion";
import { useMemo } from "react";

interface Props extends WithChildren {
  accordionKey: string;
}

export const AccordionContainer = ({ children, accordionKey }: Props) => {
  const { createAccordion } = useAccordionContext();

  const { element: Accordion } = useMemo(
    () => createAccordion(accordionKey),
    []
  );

  return (
    <Accordion isAbsolute>
      <div className={styles.container} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>{children}</div>
      </div>
    </Accordion>
  );
};
